import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'secure', pathMatch: 'full' },
  {
    path: 'secure',
    loadChildren: () =>
      import('./securehome/securehome.module').then((m) => m.SecureModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
